import omit from "@/utils/omit";
import React from "react";

const IconSad: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="yfm-icon yfm-icon-sad"
    {...omit(props, ["className"])}
  >
    <circle
      cx="20"
      cy="20"
      r="18"
      fill="#FFD93B"
      stroke="#F4C534"
      strokeWidth="2"
    />
    <ellipse cx="13.5" cy="16" rx="3" ry="4" fill="#3E4347" />
    <ellipse cx="26.5" cy="16" rx="3" ry="4" fill="#3E4347" />
    <path
      d="M13 29 Q20 23 27 29"
      stroke="#3E4347"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

export default IconSad;
